import { type JSX } from 'react';
import { useLocale } from '@repo/i18n';
import Button from 'src/components/common/timeslots-buttons/button/Button';
import { useNativeMemberContext } from './NativeMemberContext';

// Logged-out: opens the native login modal. Logged-in: logs out.
// Renders nothing unless the tenant runs native membership.
export default function MemberLoginButton(): JSX.Element | null {
    const { t } = useLocale();
    const { isNative, isLoggedIn, openLoginModal, logout } = useNativeMemberContext();

    if (!isNative) return null;

    return isLoggedIn ? (
        <Button variant="outlined" text={t.logout} onClick={() => void logout()} />
    ) : (
        <Button text={t.login} onClick={openLoginModal} />
    );
}
